import { Component, input, inject } from '@angular/core';

// Types
import { DriversDTO } from '@portal/app/dashboard/context-modal/context-model.types';
import {
  FormatOmniValuePipe,
  OmniModelViewType,
  OmniValueDisplay
} from '@portal/app/shared/pipes/format-adjustment-factor-omni-value.pipe';

export enum Column {
  one = 'one',
  two = 'two'
}

@Component({
  selector: 'portal-context-driver-display',
  templateUrl: './driver-display.component.html',
  styleUrl: './driver-display.component.scss',
  providers: [FormatOmniValuePipe],
  standalone: false
})
export class DriverDisplayComponent {
  columnType = Column;
  column = input<Column>(Column.two);
  drivers = input<DriversDTO[] | undefined>();
  isSpendLevel = input<boolean>(false);
  viewType = input<OmniModelViewType>('tactic');

  readonly ADJUSTMENT_FACTOR_LABEL = 'Adjustment Factor';

  // Inject the pipe
  private formatOmniValuePipe = inject(FormatOmniValuePipe);

  getFormattedOmniDisplay(driver: DriversDTO): OmniValueDisplay | undefined {
    let omniValue = undefined;
    if (driver.label === this.ADJUSTMENT_FACTOR_LABEL) {
      if (!this.isSpendLevel() && driver.value === 0) {
        return omniValue;
      }
      const value = this.isSpendLevel() ? -1 : driver.formattedValue;
      omniValue = this.formatOmniValuePipe.transform(
        value,
        'percInc',
        this.viewType()
      );
    }
    return omniValue;
  }
}
